module.exports = __webpack_public_path__ + "static/media/ic-contact-phone.3bd4fd75.svg";